module.exports = __webpack_public_path__ + "media/packs/images/flags/NC-e82bab6894add129dab3f0f400cfb33e.svg";